import { take, put, call, select, takeEvery } from 'redux-saga/effects'
import { makeSaga } from './util'

import { types as clubTypes, actions as clubActions, selectors as clubSelectors } from '../reducers/clubs'

import { getEffect } from './network'
import gql from 'graphql-tag'
import apolloClient from '../apollo'
import { isLocal } from '../config'

const clubsQuery = gql`
  query localClubs {
    getAllClubs {
      id
      name
      active
      customer
    }
  }
`

const clubQuery = gql`
  query localClub($id: ID!) {
    club(id: $id) {
      id
      name
      active
      customer
    }
  }
`

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * getClubEffect ({ clubId }) {
  if (isLocal) {
    try {
      const { data: { club } } = yield call([apolloClient, apolloClient.query], {
        query: clubQuery,
        variables: { id: String(clubId) }
      })
      return club
    } catch (error) {
      return { error }
    }
  }
  const request = {
    url: 'clubs/' + clubId
  }
  const chan = yield call(getEffect, request)
  return yield take(chan)
}

export function * getClubsEffect () {
  if (isLocal) {
    try {
      const { data: { getAllClubs } } = yield call([apolloClient, apolloClient.query], { query: clubsQuery })
      return getAllClubs
    } catch (error) {
      return { error }
    }
  }
  const request = {
    url: 'clubs',
    options: {
      headers: {
        'If-Modified-Since': 'Thu, 01 Jan 1970 01:00:00'
      }
    }
  }
  const chan = yield call(getEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * getClubFlow ({ payload }) {
  const localClub = yield select(clubSelectors.clubById(payload.clubId))
  if (localClub) {
    yield put(clubActions.successRequest())
    return
  }
  const club = yield call(getClubEffect, payload)
  if (club.error) {
    yield put(clubActions.successRequest())
    return
  }
  yield put(clubActions.finishRequest(club))
  yield put(clubActions.successRequest())
}

export function * getClubsFlow () {
  const clubs = yield call(getClubsEffect)
  if (clubs.error) {
    yield put(clubActions.successRequest())
    return
  }
  yield put(clubActions.finishRequestMulti(clubs))
  yield put(clubActions.successRequest())
}

export default makeSaga([
  takeEvery(clubTypes.CLUB_REQUEST, getClubFlow),
  takeEvery(clubTypes.CLUBS_REQUEST, getClubsFlow)
])
